export const getFileSizeInMb = (bytes: number) => (bytes / 1024 / 1024).toFixed();